module.exports = __webpack_public_path__ + "static/description-2-e63f5bd93e0b20091552e9b581832f49.png";